export default "__VITE_ASSET__VtJbLT73__"